module.exports = __webpack_public_path__ + "media/images/favicons/google-96x96-367990722ba6db077ddaf5224207922c.png";